export enum ErrorBoundaryCause {
  ProjectAccessDenied = "ProjectAccessDenied",
  ProjectDoesNotExist = "ProjectDoesNotExist",
  ValidSubscriptionRequired = "ValidSubscriptionRequired",
}
